<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: zh
 * @Date: 2021-10-12 14:43:42
 * @LastEditors: zh
 * @LastEditTime: 2022-02-17 14:04:51
-->
<template>
  <div class="container">
    <div class="bgoverlay">
      <div class="bg" :style="{'background-image': `url(${require('@/assets/images/workChanceBg.jpg')})`}"></div>
    </div>
    <div class="inner-pannel">
      <div class="pannel-content">
        <div class="pannel-content-box maxwidth-lg topPoint">
          <div class="content-page">
            <div class="ani animate__animated animate__fadeInUp">
              <div style="height:55px"></div>
              <p :class="$i18n.locale=='zh'?'zh-font':'en-font'">{{$t('workChance.content')}}</p>
              <div style="height:20px;"></div>
              <div v-if="$i18n.locale === 'en'" class="showmore" @click="changeLang">Please click to view more</div>
              <el-collapse
                v-if="$i18n.locale === 'zh'"
                style="width:577px"
                :accordion="true"
              >
                <el-collapse-item v-for="(item,index) in $t('workChance.positionList')" :key="index" :title="item.position">
                  <div class="title">{{ $t('workChance.title1') }}</div>
                  <div v-for="(ele1,index1) in item.jobContent" :key="index1" :class="$i18n.locale=='zh'?'zh-font':'en-font'" style="color:#ffffff">{{ele1}}</div>
                  <div class="title">{{ $t('workChance.title2') }}</div>
                  <div v-for="(ele2,index2) in item.jobRequirement" :key="index2" :class="$i18n.locale=='zh'?'zh-font':'en-font'" style="color:#ffffff">{{ele2}}</div>
                  <div class="title">{{ $t('workChance.title3') }}</div>
                  <div :class="$i18n.locale=='zh'?'zh-font':'en-font'" style="color:#ffffff">{{item.workAddress}}</div>
                  <div :class="$i18n.locale=='zh'?'zh-font':'en-font'" style="color:#ffffff">{{$t('workChance.title4')}}<span class="mail">{{item.mail}}</span> </div>
                  <div style="height:20px;"></div>
                </el-collapse-item>
              </el-collapse>  
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default({
  data() {
    return{}  
  },
  methods: {
    changeLang(){
      localStorage.setItem('lang', 'zh')
      this.$i18n.locale = 'zh'
      this.$router.go(0)
    }
  }
})
</script>

<style scoped>
  .topPoint::after {
    width: 25px;
    height: 25px;
    content: "";
    position: absolute;
    background: #ed6d00;
    border-radius: 50%;
    z-index: 1;
    top: -12.5px;
    right: -12.5px;
  }
  /deep/ .el-collapse-item__wrap{
    padding-left: 0;
  }
  /deep/ .el-collapse {
    border-bottom: 0;
  }
  /deep/ .el-collapse-item__wrap{
    border-bottom: 0;
  }
  .inner-pannel{
    min-height: 100%;
    padding-bottom: 54px;
    position: static;
    /* position: relative; */
    /* position: absolute; */
    width: 100%;
  }
  .title{
    color: #ed6d00;
    padding: 10px 0;
  }
  .mail{
    color: #ed6d00;
    margin-left: 5px;
  }
  .showmore{
    color: #ed6d00;
    cursor: pointer;
    font-family: 'Lato';
  }
  @media screen and (max-width:768px) {
    /deep/ .el-collapse {
      width: 100%!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/workChance/workChance.vue